import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#FFFFFF",
        secondary: "#1976d2",
        info: "#8aafe8",
        accent: "#192b46",
        success: "#00a65a",
        atention: "#ff5722",
        error: "#d33724",
      },
    },
  },
});
